import { Edge, Node } from '@xyflow/react'
import { IEdgeType, INodeType } from '../types/wizard-flow'
import { IWizardBlock } from '../types/wizard-types'

export const initialNodes: Node<IWizardBlock>[] = [
    {
        id: 'empty-trigger',
        // @ts-ignore
        data: {
            label: 'Add a Trigger',
        },
        width: 230,
        height: 60,
        position: { x: 0, y: 0 },
        type: INodeType.EMPTY_TRIGGER,
    },
]

export const actionPlaceholder: Node<IWizardBlock> = {
    id: 'action-placeholder',
    // @ts-ignore
    data: { label: 'Add' },
    position: { x: 0, y: 0 },
    type: INodeType.PLACEHOLDER_NODE,
    height: 60,
    width: 100,
    zIndex: 1,
}

export const conditionBlockPlaceholder: Node<IWizardBlock> = {
    id: 'condition-placeholder',
    // @ts-ignore
    data: { label: 'Add' },
    position: { x: 0, y: 0 },
    type: INodeType.PLACEHOLDER_CONDITION,
    height: 60,
    width: 100,
    zIndex: 1,
}

export const initialEdges: Edge[] = [
    {
        id: 'etrigger-placeholder-1',
        source: 'trigger',
        target: 'placeholder-1',
        sourceHandle: 'bottom',
        targetHandle: 'top',
        type: IEdgeType.CUSTOM_EDGE,
    },
]
